<template>
  <CustomModal
    class="suggest-hotel-offer-category"
    :is-modal-open="isOpen"
    @toggleModal="closeModal"
    @onClickAway="closeModal"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-[100vw] tw:md:max-w-[456px] tw:md:w-[456px] tw:md:rounded-md tw:rounded-none'"
  >
    <template #modalHeader>
      <p class="tw:text-xl tw:text-gray-700">{{ $t('hotel_offer_feedback') }}</p>
    </template>

    <div>
      <p class="tw:mb-6">
        {{ $t('hotel_offer_feedback_subtext') }}
      </p>
      <textarea
        class="tw:outline-none tw:w-full tw:border tw:border-gray-500 tw:rounded-md tw:p-2 tw:h-[228px] tw:max-h-[228px]"
        :placeholder="$t('hotel_offers_feedback_box')"
        @input="setFeedback($event.target.value)"
        :value="feedback"
        maxLength="500"
      />
      <p class="tw:text-xs tw:text-gray-500">
        {{
          $t('hotel_offers_text_box_limit', {
            CharacterNumber: numberOfCharacters,
            CharacterLimit: 500,
          })
        }}
      </p>
    </div>

    <template #modalFooter>
      <div class="tw:gap-x-2 tw:w-full tw:flex tw:justify-end">
        <GhostButton @click="backAction">{{
          source === 'popup' ? $t('hotel_offers_cta_back') : $t('hotel_offers_cta_close')
        }}</GhostButton>
        <MainButton :disabled="feedback.length < 3" @click="sendFeedback">
          <span v-if="isSendSuggestionLoading"><SmallDotLoader color="#fff" /></span>
          <span v-else>{{ $t('hotel_offer_cta_feedback') }} </span>
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>
<script setup>
import { ref, computed } from 'vue'
import CustomModal from '@/components/base/CustomModal.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'

import { useSendSuggestion } from '@/components/hotelOffers/queries'
import useToastNotifications from '@/components/notifications/useToastNotifications'
import { selectedAccommodationId } from '@/layouts/queries'

const props = defineProps({
  isOpen: Boolean,
  source: String,
  offer: Object,
})
const { displayNotification } = useToastNotifications()
const { isSendSuggestionLoading, sendSuggestion } = useSendSuggestion()
const feedback = ref('')
const numberOfCharacters = computed(() => feedback.value.length)
const emit = defineEmits(['closeModal', 'openCreateOfferOpen'])
const openCreateOfferOpen = () =>
  emit('openCreateOfferOpen', { offerName: props.offer ? props.offer.name : null, source: 'suggestions' })
const closeModal = () => {
  feedback.value = ''
  if (props.source === 'popup') {
    openCreateOfferOpen()
  }
  emit('closeModal')
}

const setFeedback = value => {
  feedback.value = value
}

const sendFeedback = () => {
  sendSuggestion(
    { feedback: feedback.value, itemId: selectedAccommodationId.value },
    {
      onSuccess: () => {
        if (props.source === 'popup') {
          openCreateOfferOpen()
        }
        displayNotification({
          message: 'hotel_offers_feedback_success',
          isTranslationKey: true,
          type: 'success',
        })
        closeModal()
      },
      onError: () => {
        displayNotification({
          message: 'something_went_wrong',
          isTranslationKey: true,
          type: 'error',
        })
      },
    }
  )
}

const backAction = () => {
  if (props.source === 'popup') {
    closeModal()
    openCreateOfferOpen()
  } else {
    closeModal()
  }
}
</script>
